import { render, staticRenderFns } from "./SelectMandant.vue?vue&type=template&id=5447539e"
import script from "./SelectMandant.vue?vue&type=script&lang=js"
export * from "./SelectMandant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports